module.exports = __webpack_public_path__ + "static/img/91BM-063-JinhaiChen.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-063-JinhaiChen.jpg
// module id = NeQO
// module chunks = 0